import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const ComponentTestimonials = () => {
    const componentMobile = document.querySelector('[data-component="testimonials"] .swiper');
    const componentDesktop = document.querySelector('[data-component="testimonials"] aside');

    const swiper = new Swiper('[data-component="testimonials"] .swiper', {
        modules: [Pagination, Navigation],
        loop: true,
        grabCursor: true,
        spaceBetween: 20,
        slidesPerView: 1,
        navigation: {
            nextEl: '[data-component="testimonials"] .swiper-button-next',
            prevEl: '[data-component="testimonials"] .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
        },
    });
};

export default ComponentTestimonials;
